import {
  FT_KEY,
  relationshipsUrls,
  soiUrls,
  VERSION,
} from "../../constants/ApiUrls";

import {
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getSharesOfInheritanceList = async (id, refreshedData) => {
  let url =
    FT_KEY +
    VERSION +
    `${id}/${soiUrls.GET_SHARE_OF_INHERITANCE_LIST}?isRefresh=${refreshedData}`;
  return await getData(url);
};

export const updateSharesOfInheritanceList = async (id, data) => {
  let url =
    FT_KEY + VERSION + `${id}/${soiUrls.UPDATE_SHARE_OF_INHERITANCE_LIST}`;

  return await updateData(url, data);
};

export const getAllRelations = async (id) => {
  // let url = `${id}/${relationshipsUrls.ALL_RELATIONSHIP}`;
  return await getData(FT_KEY + VERSION + relationshipsUrls.ALL_RELATIONSHIP);
};

export const addRelationship = async (payload) => {
  return await postData(FT_KEY + VERSION + soiUrls.GET_TAX, payload);
};
